<script>
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";

import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import kesinlesenkarar from "./kesinlesenkarar.vue";

export default {
  props: ["satdosyaId"],
  mixins: [apibtoast, apigeneric],
  page: {
    title: "Kesinleşen İhale Kararı",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    kesinlesenkarar,
  },
  data() {
    return {
      title: "Kesinleşen İhale Kararı",
      FormData: {},
      satdosya: {},

      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "50",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      SecilenFirmaid: "",
      OlcuBirimleri: [],
      excele_aktar: 0,
      pdf_aktar: 0,
      islem: 0,
      guncelle: 0,
      uri: "data:application/vnd.ms-excel;base64,",
      template: '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function(s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function(s, c) {
        return s.replace(/{(\w+)}/g, function(m, p) {
          return c[p];
        });
      },
    };
  },

  methods: {
    Get() {
      this.$emit("aktif_menu_title", "Kesinleşen İhale Kararı");

      this.ActionsSingleGet({
        Service: "satdosya",
        Id: this.satdosyaId,
      }).then((res) => {
        this.satdosya = res.Data;
      });

      this.ActionsFilterGet({ Service: "satdosyafirma", Page: this.Page, Filter: "&Dosyaid=" + this.satdosyaId + "&Firmaturu=3" }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },

    SatDosyaUpdate() {
      this.Update("satdosya", this.satdosya);
    },
  },
  watch: {
    satdosyaId() {
      this.Get();
    },
  },
};
</script>

<template>
  <Loader>
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-md-12">
                <div class="row mb-2">
                  <div class="col-sm-4">
                    <h5>Kesin Karar Tarihi</h5>
                    <b-form-input v-model="satdosya.Ihalekesinlesenkararitarihi" @input="SatDosyaUpdate()" id="date" type="datetime-local"></b-form-input>
                  </div>
                  <div class="col-sm-4">
                    <h5>Komisyon Kararı Onay Tarihi</h5>
                    <b-form-input v-model="satdosya.Ihalekomisyonkararionaytarihi" @input="SatDosyaUpdate()" id="date" type="datetime-local"></b-form-input>
                  </div>
                </div>

                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead class="table-light">
                      <tr>
                        <th>Firma Adı</th>
                        <th width="100"><center>İşlem</center></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="Data in TableData" :key="Data.Id">
                        <th scope="row">{{ Data.Firmaadi }}</th>
                        <td style="width: 85px; text-align: center;">
                          <b-button-group>
                            <b-button @click="(guncelle = guncelle + 1), (SecilenFirmaid = Data.Firmaid)" v-b-modal.kesinlesenkarar v-tooltip="'Yazdır'" variant="primary">
                              <i class="far fa-print"></i>
                            </b-button>
                          </b-button-group>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <kesinlesenkarar :satdosyaId="satdosyaId" :SecilenFirmaid="SecilenFirmaid" v-show="guncelle > 0" :guncelle="guncelle" />
  </Loader>
</template>
